module.exports = __webpack_public_path__ + "img/Priest-human-m-60.fc4d5ca6.gif";